import { ADT } from "pb.adt";

export const Page = ADT.define(
	{} as {
		Initialising: true;
		// transaction states
		AwaitProcessing: true;
		AwaitAccountSelection: {
			onClose: () => void;
			cancelling?: boolean;
		};
		AwaitApplicationSelection: {
			onClose: () => void;
			cancelling?: boolean;
		};
		AwaitPaymentMethod: {
			onClose: () => void;
			cancelling?: boolean;
		};
		AwaitPinEntry: {
			onClose: () => void;
			cancelling?: boolean;
		};
		AwaitSignature: {
			onClose: () => void;
			cancelling?: boolean;
		};
		DisplayPaymentMessage: {
			onClose: () => void;
			cancelling?: boolean;
		};
		SignatureSubmitted: {
			signature?: string;
			onClose: () => void;
			onApprove: () => void;
			onDecline: () => void;
			cancelling?: boolean;
		};
		// response states
		Approved: {
			currency?: string;
			totalCents: number;
			onDone: () => void;
		};
		Declined: {
			title: string;
			subtitle?: string;
			message?: string;
			onRetry: () => void;
			onCancel: () => void;
		};
		Cancelled: {
			onClose: () => void;
		};
		ErrorDisconnected: {
			onClose: () => void;
			onRetry: () => void;
		};
		ErrorInactivityTimeout: {
			onClose: () => void;
			onRetry: () => void;
		};
		ErrorNetwork: {
			onClose: () => void;
			onRetry: () => void;
		};
		ErrorOperation: {
			onClose: () => void;
			onRetry?: () => void;
		};
		ErrorTerminalBusy: {
			onClose: () => void;
			onRetry: () => void;
		};
		ErrorTerminalUnreachable: {
			onClose: () => void;
			onRetry: () => void;
		};
		ErrorTerminalMissing: {
			onClose: () => void;
		};
	},
);

export type Page = ADT.define<typeof Page>;
